import { Skeleton } from "@/components/ui/skeleton"
import { ScrollableRouteContainer } from "@/components/shared/Container.tsx"
import { PageBody, PageHeader } from "@/components/shared/page-sections.tsx"

export const SkeletonPageLoading = () => (
  <ScrollableRouteContainer className={`p-0`}>
    <PageHeader className={`flex flex-col gap-6`}>
      <Skeleton className="h-12 w-full rounded-md max-w-32" />
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-12 w-full rounded-md max-w-xs" />
        <Skeleton className="h-12 w-full rounded-md max-w-xs" />
      </div>
    </PageHeader>
    <PageBody className="flex flex-col gap-6">
      <Skeleton className="h-48 w-full rounded-md" />
      <Skeleton className="h-48 w-full rounded-md" />
    </PageBody>
  </ScrollableRouteContainer>
)
